import * as React from "react";
import { Leaf, BadgeDollarSign, MapPin } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
const features = [{
  title: "Preventative Wellness",
  description: "Our board-certified providers emphasize long-term health through proactive screenings and personalized wellness plans.",
  icon: Leaf,
  iconColor: "text-chart-2",
  link: "/HomePage"
}, {
  title: "Affordable Excellence",
  description: "We believe high-quality healthcare should be accessible. Experience transparent pricing and a focus on value-based care.",
  icon: BadgeDollarSign,
  iconColor: "text-primary",
  link: "/HomePage"
}, {
  title: "Safety Harbor Local",
  description: "Conveniently located for our community, providing fast walk-in service and reliable primary care when you need it most.",
  icon: MapPin,
  iconColor: "text-chart-2",
  link: "/HomePage"
}];
export default function TheJunkDaddyDifference() {
  return <section data-section-id="225002" id="why-choose-dr-kaszuba" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl">
            Why Choose Dr. Kaszuba?
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground font-default">We combine clinical precision with a warm, patient-centered approach. Discover why Safety Harbor patients trust us for their primary and urgent care needs.</p>
        </div>

        <div className="grid grid-cols-1 gap-6 !h-[275px] md:grid-cols-3">
          {features.map((feature, i) => <div data-index={i} key={i} className="group relative h-full">
              <div className="absolute inset-0 z-10" />
              <Card className="flex h-full flex-col justify-between rounded-3xl border border-border bg-card shadow-4xl transition-all duration-300 group-hover:border-chart-2 group-hover:scale-[1.02]">
                <div>
                  <CardHeader className="pb-4">
                    <feature.icon className={`mb-4 size-16 stroke-[2] ${feature.iconColor}`} aria-hidden="true" />
                    <CardTitle className="font-default text-2xl font-bold text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-muted-foreground font-default">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}